import {BaseBlock, theme} from "../../../framework/js/core";

class CateringSection {
  constructor(root) {
    this.root = root;
    this._header = root.find(".cs-list__section__header");
    this._body = root.find(".cs-list__section__body");
    this._shown = false;
    
    this._header.on("click", event => {
      this.toggle();
    });
  }
  
  show() {
    this.root.addClass("section-visible").removeClass("section-hidden");
    this._body.slideDown("slow");
    this._shown = true;
  }
  
  hide() {
    this.root.removeClass("section-visible").addClass("section-hidden");
    this._body.slideUp("slow");
    this._shown = false;
  }
  
  toggle() {
    this._shown ? this.hide() : this.show();
  }
}

export class CateringSummaryList extends BaseBlock {
  constructor(root) {
    super(root);
    
    this.sections = this.root.find(".cs-list__section").mapEach(section => new CateringSection(section));
    this.sections.forEach((section, i) => {
      i > 0 ? section.hide() : section.show();
    });
  }
}